import { render, staticRenderFns } from "./EmailBatch.vue?vue&type=template&id=cbedd210&scoped=true"
import script from "./EmailBatch.vue?vue&type=script&lang=js"
export * from "./EmailBatch.vue?vue&type=script&lang=js"
import style0 from "./EmailBatch.vue?vue&type=style&index=0&id=cbedd210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbedd210",
  null
  
)

export default component.exports